import React from 'react';
import classNames from "classnames";

export function PrivacyAgreement() {

    const sectionClass = classNames("my-5")
    const headerClass = classNames("mb-3 text-center mt-4")
    const subHeaderClass = classNames("mb-2 mt-4 fw-bold")

    return (
        <div>
            <div className={"container w-75 p-5 fs-5 text-justify"}>

                <h1>Personvernerklæring</h1>
                <p>
                    Karakterboost AS innhenter og lagrer personopplysninger når eleven
                    fyller ut personalia i forbindelse med brukeropprettelse, ved bruk av
                    AI, og ved bestilling av kurs.
                </p>

                <div className={sectionClass}>
                    <h2 className={headerClass}>Karakterboost AS samler inn informasjon på følgende vis:</h2>
                    <h3 className={subHeaderClass}>a) Informasjon du selv gir oss</h3>
                    <p>
                        Når eleven bestiller fag, bruker chattefunksjon, sender oss e – post
                        eller andre interaksjoner med nettsiden vil personalia både
                        registreres og lagres.
                    </p>

                    <p>
                        Informasjonen lagres i databasen for at Karakterboost AS skal kunne
                        tilby eller sikre leveranse av de kurs som eleven har bestilt, for å
                        forhindre svindel og for å forbedre våre tjenester. Vi vil også lagre
                        informasjon når du kontakter oss ved å sende e-post. Slik informasjon
                        kan for eksempel være e-postadresse, telefonnummer og innholdet i
                        e-posthenvendelsen, slik at vi kan svare på spørsmålene dine.
                    </p>

                    <h3 className={subHeaderClass}>b) Informasjon som samles inn når du bruker nettsiden</h3>
                    <p>
                        Når eleven besøker nettsiden, vil Karakterboost AS samle inn
                        informasjon om aktiviteten på nettsiden. Med det menes hvilke
                        tjenester og/eller sider du besøker hos oss, og hvordan du bruker
                        Karakterboost ©
                        Side 7 av 13
                        dem. Denne informasjonen deles i to kategorier som har to ulike
                        bruksområder:

                    </p>

                    <h4 className={"text-decoration-underline"}>Informasjon om bruk av nettsiden</h4>
                    <p>
                        Noe informasjon lagres etter anmodning fra deg, for eksempel
                        når du bestiller kurs. Vi bruker denne typen informasjon blant
                        annet til å forbedre tjenestene våre, til å forhindre misbruk av
                        tjenestene på nettsiden og for å gi deg innhold tilpasset ditt
                        bruksmønster(for eksempel kurs og nyheter relatert til dine
                        studieønsker).
                    </p>

                    <h4 className={"text-decoration-underline"}>Teknisk informasjon</h4>

                    <p>
                        Ved hjelp av serverlogger og andre verktøy registrerer vi
                        informasjon om enheten og tilkoblingen til nettsiden vår, blant
                        annet operativsystem, nettleserversjon, IP-adresse og
                        informasjonskapsler. Slike opplysninger brukes ofte i
                        anonymisert og aggregert statistikk, men vi kan også koble dem
                        mot din brukerkonto. Opplysningene gjør blant annet at vi kan
                        tilpasse visningen av nettsiden vår til enheten du bruker, og at vi
                        kan analysere de ulike måtene som nettsiden brukes på.
                    </p>



                </div >


                <div className={sectionClass}>
                    <h2 className={headerClass}>Hva Karakterboost AS bruker informasjonen til</h2>
                    <p>
                        Vi behandler personopplysninger vi innheter for å levere optimale
                        tjenester. De er vesentlige for å forbedre og videreutvikle dagens
                        plattform samt å kunne informere om nye måter å bruke våre
                        tjenester på.
                    </p>

                    <p>
                        Personopplysningene brukes også for å kunne gi et tilbud tilpasset
                        elevenes behov, for eventuell analyse, men også for å forutsi
                        fremtidig atferd og forstå trender i markedet.
                    </p>

                    <p>
                        Personopplysningene brukes også for å kunne gi et tilbud tilpasset
                        elevenes behov, for eventuell analyse, men også for å forutsi
                        fremtidig atferd og forstå trender i markedet.
                    </p>

                    <h3 className={subHeaderClass}>a) Forbedre brukeropplevelsen</h3>
                    <p>
                        Vi bruker det innsamlede datamaterialet for å kunne tilby en nettside
                        som er mer brukervennlig. For eksempel kan vi undersøke om
                        brukere med en bestemt nettleser eller mobiltelefon har problemer
                        med å bestille kurs, slik at vi kan forbedre vårt brukergrensesnitt.
                        Informasjonen som behandles til dette formålet vil normalt bli brukt i
                        aggregert og anonymisert form.
                    </p>

                    <h3 className={subHeaderClass}>b) Begrense misbruk</h3>
                    <p>
                        Vi bruker informasjon knyttet til brukernes aktiviteter og tekniske
                        data for å begrense ulike former for misbruk av våre tjenester. Med
                        misbruk menes blant annet forsøk på svindel, «spamming», forsøk på
                        å logge inn på andres brukerkontoer, trakassering og generelt
                        handlinger som er forbudt ved norsk lov.
                    </p>

                </div>

                <div className={sectionClass}>
                    <h2 className={headerClass}>Deling og utlevering av informasjon</h2>
                    <p>
                        Hvis det er mistanke om at det har skjedd lovbrudd i forbindelse med
                        bruk av tjenestene våre, vil opplysninger kunne bli utlevert til
                        offentlige myndigheter ved begjæring.
                    </p>
                    <p>
                        Vi vil ikke selge, dele, overføre eller offentliggjøre dine
                        personopplysninger på noen annen måte enn det som er beskrevet i
                        denne personvernerklæringen, med mindre vi blir pålagt dette av
                        offentlige myndigheter eller ved samtykke.
                    </p>
                </div>

                <div className={sectionClass}>
                    <h2 className={headerClass}>Dine rettigheter når vi innhenter personopplysninger om deg</h2>
                    <p>
                        Du har rett til å be om tilgang, retting eller sletting av dine
                        personopplysninger. Du har også rett til å be om begrenset
                        behandling, protestere mot behandlingen, og be om rett til
                        dataportabilitet. Du kan lese mer om omfanget av disse rettighetene
                        på Datatilsynets nettside: www.datatilsynet.no.
                    </p>
                    <p>
                        Hvis du er kunde hos oss, kan du få tilgang til de personopplysningene
                        vi behandler om deg, gjennom Min Side.
                    </p>
                    <p>
                        Du har alltid muligheten til å trekke tilbake eller endre eventuelle
                        samtykker for utsendelse av tilbud og nyhetsbrev.
                    </p>
                    <p>
                        Vi vil be deg om å bekrefte identiteten din eller gi mer informasjon før
                        vi lar deg utøve rettighetene dine overfor oss. Dette gjør vi for å sikre
                        at vi kun gir deg tilgang til personopplysningene dine, og ikke til noen
                        som utgir seg for å være deg.
                    </p>
                </div>


                <div className={sectionClass}>
                    <h2 className={headerClass}>Sikring av personopplysninger</h2>
                    <p>
                        For å sikre at uvedkommende ikke får tilgang til dine
                        personopplysninger, og at all behandling av opplysningene skjer i
                        samsvar med gjeldende lovverk, har vi rutiner og tiltak på forskjellige
                        nivåer. Disse tiltakene inkluderer regelmessige risikovurderinger,
                        tekniske systemer og fysiske prosedyrer for å sikre at opplysningene
                        er sikre, og vi har også rutiner for å verifisere forespørsler om innsyn i
                        og korrigering av personopplysninger.

                    </p>
                </div>

                <div className={sectionClass}>
                    <h2 className={headerClass}>Sletting av personopplysninger</h2>
                    <p>
                        Vi lagrer ikke personopplysninger lenger enn hva som er nødvendig
                        for å oppfylle formålet med behandlingen. I tillegg kan du når som
                        helst be oss om å slette informasjon som er knyttet til deg, med
                        mindre opplysningene er nødvendige for å levere en tjeneste som du
                        fortsatt ønsker å ha tilgang til, eller det er pålagt ved lov å oppbevare
                        opplysningene for en viss tid (for eksempel enkelte opplysninger
                        knyttet til kjøp av tjenester i tråd med gjeldende
                        regnskapslovgivning).

                    </p>
                    <p>
                        Hvis det er ønskelig, kan du kontakte oss for å få vite mer om hvordan
                        vi behandler dine personopplysninger.
                    </p>
                </div>

                <div className={sectionClass}>
                    <h2 className={headerClass}>Klager</h2>
                    <p>
                        Hvis du mener at behandlingen vår av personopplysninger ikke
                        stemmer med det vi har beskrevet her eller at vi på andre måter
                        bryter personvernlovgivningen, kan du klage til Datatilsynet. Du finner
                        informasjon om hvordan du kan kontakte Datatilsynet på
                        Datatilsynets nettsider.
                    </p>
                </div>

                <div className={sectionClass}>
                    <h2 className={headerClass}>Endringer</h2>
                    <p>
                        Hvis det skjer en endring av tjenestene våre eller endringer i
                        regelverket om behandling av personopplysninger, kan det medføre
                        endringer i informasjonen du har fått her. Dersom vi har din
                        kontaktinformasjon, vil vi gjøre deg oppmerksom på disse
                        endringene.
                    </p>
                </div>

                <div className={sectionClass}>
                    <h2 className={headerClass}>
                        Informasjonskapsler (cookies)
                    </h2>

                    <p>
                        Vi bruker informasjonskapsler (cookies) blant annet for å kunne
                        tilpasse nettsiden mot våre eksisterende og fremtidige elever, for å
                        analysere hvordan du bruker nettsiden, og i enkelte tilfeller for å yte
                        markedsføring som er spesifikt rettet mot nåværende og fremtidige
                        kunder.
                    </p>

                    <ul>
                        <li>
                            Opplysningene blir ikke brukt til å identifisere besøkende på
                            nettsiden, og inneholder ingen personlig informasjon som navn
                            eller e-postadresse eller annen informasjon som vil kunne
                            krenke personvernet ditt.
                        </li>
                    </ul>

                    <p>Nødvendige cookies du samtykker til</p>
                    <ol>
                        <li>
                            Når du logger inn hos oss brukes cookies for å holde deg
                            innlogget mens du tar i bruk tjenesten.
                        </li>
                        <li>
                            Skiller mennesker fra roboter for å forhindre spam.
                        </li>
                        <li>
                            Holde oversikt over hva du har lagt i handlekurven
                        </li>
                    </ol>
                    <p>
                        Ved å bruke nettsidene våre samtykker du til bruk av
                        informasjonskapsler. Hvis du ikke samtykker til bruk av cookies, må du
                        endre på innstillingene i nettleseren din.
                        Vær imidlertid oppmerksom på at ved å endre innstillingene, kan det
                        føre til at en del funksjoner og tjenester ikke lenger kan brukes siden
                        de er avhengig av at hjemmesiden husker de valgene du har foretatt.
                    </p>
                    <p>
                        Cookies som du tidligere har akseptert, kan du enkelt slette. Du kan
                        finne mer informasjon på denne siden: https://nettvett.no/slik-administrer-du-informasjonskapsler
                    </p>
                </div>
            </div>

        </div>
    )

}